import json2mq from 'json2mq';
export function createMediaQuery(query) {
  return typeof query === 'string' ? query.replace(/^@media( ?)/m, '') : json2mq(query);
}